import Tooltip from "@mui/material/Tooltip";

import classes from './TextContent.module.css'

function TextContent({ apy, effective_at, min_to_open}) {
    return(
        <div className={classes.container}>
          <div className={classes.previewItem}>
            <p>
              <Tooltip
                title={
                  "APY, or annual percentage yield, is the yearly return on a bank or investment account."
                }
              >
                <span className={classes.underline}>{"APY"}</span>
              </Tooltip>{" "}
              {`as of ${effective_at}`}
            </p>
            <p className={classes.apyText}>{apy.toFixed(2)}%</p>
          </div>
          <div className={classes.previewItem}>
            <p>
              Min. Balance for APY
            </p>
            <p className={classes.apyText}>${min_to_open}</p>
          </div>
        </div>
    )
}

export default TextContent